import antdES from "antd/lib/locale/es_ES"
import enMessages from "../locales/es_ES.json"

const esLang = {
  messages: {
    ...enMessages
  },
  antd: antdES,
  locale: "es_ES"
}

export default esLang

